import { createSelector } from 'reselect';
import { FormSlice } from '@optum-uhone-hmkts/rise';

const selectActiveFormData = (app: any) => FormSlice.selectState(app).activeForm.originalData;
const SENIOR_FORM_PREFIX = 'H.Over65';

// selector to determine if contact is senior using fact finder master form name
export const selectIsSenior = createSelector(
    [selectActiveFormData],
    activeFormData => {
        if (!activeFormData) {
            return false;
        }
        const masterFormId = activeFormData.masterFormId;
        return masterFormId?.startsWith(SENIOR_FORM_PREFIX);
    }
);